import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Llegué sintiendo que no podía más con la ansiedad. En pocas sesiones empecé a entender qué me pasaba y me llevé herramientas que uso todos los días. Me cambió la vida.',
  author: 'Paciente, 34 años'
}, {
  quote: 'El espacio que brinda es de una calidez increíble. Nunca me sentí juzgada, sino profundamente escuchada. Pude sanar heridas que venía arrastrando hace años.',
  author: 'Paciente, 28 años'
}, {
  quote: 'Fuimos por terapia de pareja cuando creíamos que ya no había solución. Nos ayudó a volver a comunicarnos desde el amor y el respeto. Estamos muy agradecidos.',
  author: 'Pareja, 42 y 45 años'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function Testimonials() {
  return <section className="py-24 px-6 lg:px-12 max-w-7xl mx-auto" data-id="element-92">
      <motion.div className="text-center mb-16" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-93">
        <h2 className="text-4xl md:text-5xl font-serif text-dark mb-4" data-id="element-94">
          Lo que dicen quienes confiaron en el proceso
        </h2>
        <p className="text-medium text-lg max-w-2xl mx-auto" data-id="element-95">
          Experiencias reales de transformación y bienestar.
        </p>
      </motion.div>

      <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} data-id="element-96">
        {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="bg-crema-light p-8 rounded-[2rem] shadow-neumorph relative flex flex-col" data-id="element-97">
            <Quote className="text-eucalipto/20 w-16 h-16 absolute top-6 left-6" data-id="element-98" />
            <div className="relative z-10 flex-grow pt-8" data-id="element-99">
              <p className="text-medium italic leading-relaxed mb-6 text-lg" data-id="element-100">
                "{testimonial.quote}"
              </p>
            </div>
            <div className="relative z-10 mt-auto pt-4 border-t border-eucalipto/20" data-id="element-101">
              <p className="text-dark font-medium font-serif" data-id="element-102">
                — {testimonial.author}
              </p>
            </div>
          </motion.div>)}
      </motion.div>
    </section>;
}